define((require) => {
    "use strict";

    const Class                                            = require("shared/util/Class");
    const Window                                           = require("shared/services/Window");
    const {trim, isBlank}                                  = require("shared/util/StringUtils");
    const Preconditions                                    = require("shared/util/Preconditions");
    const SalesforceCommerceQuickViewSiteGenesisStrategy           = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStrategy");
    const SalesforceCommerceQuickViewSiteGenesisStandardStrategy   = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisStandardStrategy");
    const SalesforceCommerceQuickViewSiteGenesisCustomStrategy     = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisCustomStrategy");
    const SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy");

    const quickview = new SalesforceCommerceQuickViewSiteGenesisStrategy();

    /**
     * Exposes a SalesforceCommerce Quick View Service Class.
     * @class SalesforceCommerceQuickViewService
     */
    return Class.extend({}, { // TODO: move logic into SalesforceCommerceAction for consistency, remove this service and strategies thereafter

        /**
         * @private
         * Checks if the standard SalesforceCommerce QuickView function (app.quickView.show) exists on client site.
         *
         * @return {Boolean} Whether the function exists or not on the global Window object.
         */
        _standardQuickViewExists() {
            const app = Window.sandbox("app");
            return (typeof Window.sandbox("quickView.show", app) === "function") && Window.sandbox(["urls", "URLs"], app);
        },

        /**
         * @private
         * Checks if the custom SalesforceCommerce QuickView function (__zmags.demandware.quickview.show)
         * exists on client site.
         *
         * @return {Boolean} Whether the function exists or not on the global Window object.
         */
        _customQuickViewExists() {
            return (typeof Window.sandbox("__zmags.demandware.quickview.show") === "function") && Window.sandbox("Urls");
        },

        /**
         * Verifies if the SalesforceCommerce QuickView function exists on the Client Web Page
         * and decides which strategy to apply.
         *
         * @return {SalesforceCommerceQuickViewSiteGenesisStrategy} The used strategy; never falsey.
         */
        demandwareQuickViewStrategy() {
            if (this._standardQuickViewExists()) {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisStandardStrategy());
            } else if (this._customQuickViewExists()) {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisCustomStrategy());
            } else {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy());
            }

            return quickview;
        },

        /**
         * Opens the SalesforceCommerce QuickView function depending on the chosen strategy.
         *
         * @param {String} productID The SalesforceCommerce product/item identifier. If falsey (blank), this method
         *                           does nothing. Leading and trailing white space will be trimmed.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         *
         * @return {jQuery} A *client site jQuery* element for the root of the SalesforceCommerce QuickView, if available;
         *                  can be falsey. The jQuery version is probably quite old!
         */
        openSalesforceCommerceQuickView(productID, experienceName, currentScene) {
            Preconditions.checkArguments(experienceName, currentScene);

            // Trim product id to help customers having pasted in for example a leading space via the editor...
            productID = trim(productID || "");

            if (Preconditions.checkState(!isBlank(productID), "Missing SalesforceCommerce Product id")) {
                return this.demandwareQuickViewStrategy().open(productID, experienceName, currentScene);
            }
            // undefined -> falsey
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewService.js